import React, { Component } from 'react'
import { Link } from 'react-router-dom';

import { globalSettings } from '../../helpers/settings';
import Menu from '../main/Menu';

export default class NotFound extends Component {
    render(){
        return (
            <div>
                <Menu viewName='home'/>

                <div className='content-wrapper'>

                    {/* Content Header (Page header) */}
                    <div className='content-header'>
                        <div className='container-fluid'>
                            <div className='row mb-2'>
                                <div className='col-sm-6'>
                                    <h6 className='m-0'>{globalSettings?.labels?.notFound.es}</h6>
                                </div>{/* /.col */}
                                <div className='col-sm-6'>
                                    <ol className='breadcrumb float-sm-right'>
                                        {/* <li className='breadcrumb-item'><a href='/'>{globalSettings?.labels?.home?.es}</a></li> */}
                                        <li className='breadcrumb-item'><Link to='/'>{globalSettings?.labels?.home?.es}</Link></li>
                                        <li className='breadcrumb-item active'>{globalSettings?.labels?.notFound.es}</li>
                                    </ol>
                                </div>{/* /.col */}
                            </div>{/* /.row */}
                        </div>{/* /.container-fluid */}
                    </div>
                    {/* /.content-header */}

                    {/* Main content */}
                    <section className="content">
                        <div className="container-fluid">


                            <section className="content">
                                <div className="error-page">
                                    <h2 className="headline text-warning"> 404</h2>

                                    <div className="error-content">

                                        <h3><i className="fas fa-exclamation-triangle text-warning"></i> Oops! {globalSettings?.messages?.pageNotFound}</h3>

                                        <p>
                                            {globalSettings?.messages?.weCouldNotFindThePageYouWereLookingFor}.
                                        </p>

                                        <Link tooltip='tooltip' title={globalSettings?.labels?.home?.es} to='/' className="btn btn-outline-primary">
                                            <i className="fas fa-home"></i>
                                        </Link>

                                    </div>

                                </div>

                            </section>
                        </div>{/* /.container-fluid */}
                    </section>
                    {/* /.content */}

                </div>
            </div>
        )
    }
}